import { SET_NAVBAR } from '../actions/types';

const initialState = {
  isExpanded: false
};

export const sidebar = (state = initialState, action) => {
  switch (action.type) {
    case SET_NAVBAR:
      return {
        ...state,
        isExpanded: action.payload
      };
    default:
      return state;
  }
};
